
import React from 'react';
import UHCSidebarLine, { UHCSidebarLineProps } from '../../../../../../Dumb/Molecules/Sidebar/Line/Line';
import UHCSidebarTop from '../../../../../../Dumb/Atoms/Sidebar/Top/Top';

export interface UHCSidebarContractTopProps {
    lines:UHCSidebarLineProps[];
}

const UHCSidebarContractTop: React.FC<UHCSidebarContractTopProps> = (props: UHCSidebarContractTopProps) => {

    return(
        <UHCSidebarTop>
            {props.lines.map((val, index) => {
                return(
                    <div className="sidebar-top-line" key={index}>
                        <UHCSidebarLine title={val.title} lineContent={val.lineContent} />
                        {(index < props.lines.length-1)?
                            <hr />:null
                        }
                    </div>
                )
            })}
        </UHCSidebarTop>
    )
}

export default UHCSidebarContractTop;